import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ValentineBanner from './components/ValentineBanner';
import ProblemSolution from './components/ProblemSolution';
import SolutionsCarousel from './components/SolutionsCarousel';
import FeatureShowcase from './components/FeatureShowcase';
import AboutPlatform from './components/AboutPlatform';
import EquipmentStore from './components/EquipmentStore';
import SportsDemo from './components/SportsDemo';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import CaseStudyHero from './components/CaseStudyHero';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <ValentineBanner />
      <Hero />
      <SportsDemo />
      <CaseStudyHero />
      <Testimonials />
      <ProblemSolution />
      <SolutionsCarousel />
      <FeatureShowcase />
      <AboutPlatform />
      <EquipmentStore />
      <Footer />
    </div>
  );
}
